import { storeRef } from "@/components/providers/StoreProvider"
import { bookingActions } from "@/lib/redux/features/booking/reduce"
import { thunks } from "@/lib/redux/thunks"
import { HotelRoom } from "@/lib/redux/features/hotel/type"
import { getEsimCreatedOrder, getEsimOrderCode } from "@/utils/esim/esimBooking"
import { track } from "@/lib/tracking"
import dayjs from "dayjs"
import { clampHotelRoomsNum, mergeHotelGuestCriteria } from "@/utils/hotel/hotelGuestCounts"
import { toast } from "react-toastify"
import i18n from "@/lib/i18n"

export const handleChooseHotel = async (
  room: HotelRoom,
  callback: (orderCode: string) => void,
  roomsNum?: number,
) => {
  const formSearch = storeRef.current?.getState().hotel.formSearch
  const hotelState = storeRef.current?.getState().hotel
  const profile = storeRef.current?.getState().user.profile.data
  const { localInfo, facilities, ...hotel }: any = hotelState?.hotels_detail.data ?? {}
  const feePolicies = hotelState?.hotels_detail.feePolicies?.length
    ? hotelState.hotels_detail.feePolicies
    : hotelState?.hotels_search.feePolicies ?? []

  const hotelData: any = {
    ...formSearch,
    roomsNum: clampHotelRoomsNum(roomsNum ?? formSearch?.roomsNum ?? 1),
    feePolicies,
    hotel: {
      ...hotel,
      localInfo,
      searchResponse: {
        ...hotel.searchResponse,
        rooms: {
          [room.roomId]: [{
            ...room
          }]
        }
      }
    }
  }

  const bodyCreateOrder = {
    TYPE: 'JSON',
    partnerId: process.env.NEXT_PUBLIC_AUTHEN_API_CLIENT_ID,
    customerCode: profile?.customerCode || "",
    orderDate: dayjs().format("YYYY-MM-DD"),
    productType: "HOTEL",
    totalAmount: 0,
    gateway: "",
    discountAmount: 0,
    serviceAmount: 0,
    feeAmount: 0,
    payWithPoint: 50,
    voucherCode: "",
    metaData: "{}",
    itinData: JSON.stringify([
      {
        ...mergeHotelGuestCriteria(
          {
            ...hotelData.hotel,
            searchResponse: {
              ...hotelData.hotel.searchResponse,
              rooms: Object.values(hotelData.hotel.searchResponse.rooms).reduce((arr: HotelRoom[], rooms) => arr.concat(rooms as HotelRoom[]), [])
            }
          },
          hotelData,
        ),
        // Search criteria not part of the hotel detail, saved so the order can be restored from the API (preview order).
        location: formSearch?.location ?? null,
        childrenAges: formSearch?.childrenAges ?? [],
        feePolicies,
      },
    ]),

    partnerRequestId: "req-123",
  }

  let createdOrder
  let orderCode
  try {
    const res = await storeRef.current?.dispatch(thunks.flight_create_order({
      body: bodyCreateOrder
    })).unwrap()

    createdOrder = getEsimCreatedOrder(res)
    orderCode = getEsimOrderCode(createdOrder)
  } catch {
    // Nơi gọi (nút "Chọn phòng") không catch: báo lỗi tại đây thay vì để unhandledRejection.
  }
  if (!orderCode) {
    toast.error(i18n.t("booking.create_order_failed"))
    return
  }

  hotelData.order = { ...(createdOrder as object), orderCode }
  localStorage.setItem('current_order_code', orderCode)

  // DOP-925: hotel_booking_start — user chọn phòng, tạo order khách sạn thành công
  track('hotel_booking_start', {
    order_id: orderCode,
    hotel_id: `${hotel?.hotelId || ''}`,
    room_id: `${room.roomId}`,
  })

  localStorage.setItem('hotel', JSON.stringify(hotelData))
  localStorage.setItem('current_time_session', `${dayjs().toString()}`)
  localStorage.removeItem('booking_flight')
  localStorage.removeItem('flights')
  storeRef.current?.dispatch(bookingActions.initChoosenHotel(hotelData))
  callback(orderCode)
}